export const articles = [
  {
    slug: "top-male-star-night-unfollow",
    title: "某顶流男星深夜取关三人：48小时时间线全复盘",
    summary:
      "从凌晨的一条取关记录，到第二天傍晚商务物料被替换，事件在48小时内完成了三次关键转折。我们把每一条公开可见的动作按时间排好，方便你自己判断。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20camera%20flash%20bursts%20in%20a%20dark%20press%20crowd%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20blurred%20paparazzi%20mood%2C%20no%20recognizable%20faces%2C%20editorial%20news%20photography&width=900&height=600&seq=dujia-art-01&orientation=landscape",
    topic: "yule",
    topicName: "娱乐圈",
    reliability: "追踪中",
    author: "瓜田观察员",
    publishedAt: "2026-09-10",
    time: "09:10",
    readMinutes: 6,
    heat: 98240,
    views: "128.6万",
    isHeadline: true,
    tags: ["取关", "顶流", "时间线"],
    timeline: [
      { time: "9月8日 02:14", title: "深夜取关", desc: "有网友发现该账号的关注列表在凌晨减少三人，均为同公司合作方。" },
      { time: "9月8日 11:40", title: "话题冲上热榜", desc: "相关讨论在两小时内进入社交平台热榜前十，工作室暂未回应。" },
      { time: "9月9日 16:20", title: "商务物料更换", desc: "一品牌官博替换了含该艺人的宣传图，官方仅称「正常物料排期调整」。" },
      { time: "9月10日 09:10", title: "站内持续跟进", desc: "事件仍未有决定性证据，后续节点将持续更新。" },
    ],
    body: [
      {
        type: "p",
        text: "事情的开始并不起眼。9月8日凌晨两点多，有细心的网友截下一张关注列表的对比图——该账号的关注人数比前一天少了三人。三个人都指向同一家合作公司，这让原本平静的深夜多了点意思。",
      },
      { type: "h2", text: "第一个转折：从「手滑」到「确有其事」" },
      {
        type: "p",
        text: "最初的主流解释是手滑。毕竟深夜操作失误并不罕见。但很快有人翻出，被取关的三人都不是当天发过动态的账号，手滑很难一次滑掉三个，而且方向一致。这个解释开始站不住脚。",
      },
      {
        type: "quote",
        text: "关注、取关这类动作本身只能说明「列表发生了变化」，它不构成任何关系判断。真正值得看的是后续有没有人出来回应。",
      },
      { type: "h2", text: "第二个转折：工作室的沉默" },
      {
        type: "p",
        text: "到9月8日中午，话题已经冲上热榜。按照常规操作，这类传闻通常会在几小时内被工作室一句「不实信息」压下去。但这一次，工作室的账号一整天没有更新，连日常的行程图都没发。沉默本身，成了新的信息。",
      },
      { type: "h2", text: "第三个转折：品牌方的动作" },
      {
        type: "p",
        text: "9月9日下午，有品牌官博被网友发现替换了一张含该艺人的宣传图。品牌方客服的回复是「正常物料排期调整」。这句话既没有否认，也没有确认，属于典型的模糊表述，反而让讨论继续升温。",
      },
      { type: "h2", text: "怎么看这件事" },
      {
        type: "list",
        items: [
          "已确认的事实：关注列表发生变化、工作室当日未按惯例回应、一品牌替换了宣传物料。",
          "仍属推测的部分：取关动机、双方是否发生矛盾、是否涉及合约变动。",
          "值得继续观察：未来一周内是否有官方声明、是否有商务合作下架。",
        ],
      },
      {
        type: "p",
        text: "我们把判断权交回给你。在没有当事方明确回应之前，任何关于动机的说法都只是猜测。站内会持续跟进，一旦出现新的公开节点，时间线会同步更新。",
      },
    ],
  },
  {
    slug: "web-celebrity-live-slip",
    title: "百万粉网红直播口误：品牌方连夜撤下联名海报",
    summary:
      "一场常规带货直播里的一句话，让联名海报在当晚被替换。品牌方至今没有正面解释，直播回放也被剪掉了十几秒。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20beam%20of%20stage%20light%20hitting%20a%20microphone%20on%20an%20empty%20dark%20stage%20with%20warm%20amber%20highlights%2C%20cinematic%20minimal%20mood%2C%20no%20people&width=900&height=600&seq=dujia-art-02&orientation=landscape",
    topic: "wanghong",
    topicName: "网红圈",
    reliability: "实锤",
    author: "爆料快线",
    publishedAt: "2026-09-09",
    time: "21:35",
    readMinutes: 5,
    heat: 87310,
    views: "96.2万",
    isHeadline: false,
    tags: ["直播", "翻车", "联名"],
    timeline: [
      { time: "9月9日 20:05", title: "直播口误", desc: "直播过程中出现一句与品牌定位明显不符的表述，弹幕瞬间刷屏。" },
      { time: "9月9日 21:35", title: "回放被剪", desc: "直播回放重新上架后，相关片段被剪掉约十几秒。" },
      { time: "9月9日 23:50", title: "海报替换", desc: "品牌官方旗舰店首页的联名海报在深夜被替换为常规主视觉。" },
    ],
    body: [
      {
        type: "p",
        text: "直播翻车这件事，往往不在于说了多重的话，而在于说错了场合。9月9日晚上八点出头，这场带货直播进行到中段，主播在介绍产品时脱口而出一句与品牌调性明显不符的表述。",
      },
      { type: "h2", text: "被剪掉的十几秒" },
      {
        type: "p",
        text: "有观众保存了当时的录制。对比之后可以发现，直播回放重新上架时，相关片段被剪掉了大约十几秒，前后衔接处有明显的跳帧。这是本次事件中唯一可以称得上「实锤」的物料。",
      },
      {
        type: "quote",
        text: "剪辑本身说明团队意识到了问题，但并不等同于品牌方的正式立场。两者不能混为一谈。",
      },
      { type: "h2", text: "品牌方的深夜动作" },
      {
        type: "p",
        text: "接近午夜时分，有网友发现品牌官方旗舰店首页的联名海报被换成了常规主视觉。整个过程中，品牌方没有发布任何说明，也没有下架联名商品，只是把首页视觉撤了下来。",
      },
      { type: "h2", text: "目前可以确认什么" },
      {
        type: "list",
        items: [
          "直播中确实出现了争议表述，且有录制留存。",
          "回放存在剪辑痕迹，争议片段被移除。",
          "品牌方替换了首页联名视觉，但未发布说明、未下架商品。",
        ],
      },
      {
        type: "p",
        text: "接下来值得关注的是：品牌方是否会给出正式说法，以及这次风波会不会影响后续的联名排期。",
      },
    ],
  },
  {
    slug: "drama-lead-same-frame",
    title: "热播剧男女主被拍同框：剧组工作人员回应耐人寻味",
    summary:
      "一组路透图让两位主演再次被绑定讨论。剧组工作人员只回了一句「以官方物料为准」，既没否认也没承认。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20film%20set%20with%20warm%20string%20lights%20and%20blurred%20bokeh%20in%20the%20evening%2C%20soft%20amber%20and%20deep%20red%20tones%2C%20cinematic%20behind%20the%20scenes%20mood%2C%20no%20people&width=900&height=600&seq=dujia-art-03&orientation=landscape",
    topic: "yingshi",
    topicName: "影视瓜",
    reliability: "待证实",
    author: "追剧小组",
    publishedAt: "2026-09-08",
    time: "18:20",
    readMinutes: 4,
    heat: 76540,
    views: "84.8万",
    isHeadline: false,
    tags: ["路透", "同框", "热播剧"],
    timeline: [
      { time: "9月7日 22:10", title: "路透图流出", desc: "一组片场外的同框照片开始在小范围流传，画面模糊但可辨识大致身形。" },
      { time: "9月8日 18:20", title: "剧方回应", desc: "剧组工作人员在粉丝群留言「一切以官方物料为准」，未正面回应。" },
    ],
    body: [
      {
        type: "p",
        text: "一部正在热播的剧集，最容易让两位主演被绑定讨论。这一次的起点是一组路透图——拍摄时间在傍晚，画面偏暗，只能大致看清两个人的身形轮廓。",
      },
      { type: "h2", text: "为什么这张图争议大" },
      {
        type: "p",
        text: "争议的核心不在于照片本身，而在于照片的拍摄场景。如果是在片场范围内，那基本可以归为正常工作接触；如果是在片场之外，讨论的性质就完全不同了。目前流出的信息无法确认具体地点。",
      },
      {
        type: "quote",
        text: "「一切以官方物料为准」是宣传口径里最常见的中性表述，它既不能证明什么，也不能否定什么。",
      },
      { type: "h2", text: "理性看这一步" },
      {
        type: "list",
        items: [
          "路透图来源不明，拍摄时间与地点均无法核实。",
          "剧方给出的回应属于常规宣传口径，不构成任何事实认定。",
          "在剧集宣传期内，两位主演的公开同框本来就会增加。",
        ],
      },
      {
        type: "p",
        text: "把这件事暂时放在「待证实」一栏更合适。真正有分量的节点，是后续是否出现更清晰的物料或者当事方更明确的表态。",
      },
    ],
  },
  {
    slug: "variety-unaired-clip",
    title: "综艺未播片段流出：那句被剪掉的话成了最大悬念",
    summary:
      "一段标着「未播」的片段在社交平台流传，内容不长，但删掉的位置很巧。节目组目前没有回应剪辑相关的疑问。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20television%20studio%20with%20empty%20host%20desk%20and%20warm%20amber%20practical%20lights%20in%20the%20background%2C%20cinematic%20minimal%20mood%2C%20no%20people&width=900&height=600&seq=dujia-art-04&orientation=landscape",
    topic: "yingshi",
    topicName: "影视瓜",
    reliability: "追踪中",
    author: "综艺观察",
    publishedAt: "2026-09-07",
    time: "14:05",
    readMinutes: 4,
    heat: 61220,
    views: "67.4万",
    isHeadline: false,
    tags: ["综艺", "未播", "剪辑"],
    timeline: [
      { time: "9月6日 19:30", title: "片段流出", desc: "一段标注「未播」的录像出现在多个社交平台，时长约一分半。" },
      { time: "9月7日 14:05", title: "对比正片", desc: "网友发现正片对应位置被重新剪辑，衔接感略有变化。" },
    ],
    body: [
      {
        type: "p",
        text: "综艺剪辑从来不是中立的。哪些留、哪些剪，本身就是一种叙事选择。这一次的悬念，来自一段标注「未播」的录像。",
      },
      { type: "h2", text: "被删掉的位置很巧" },
      {
        type: "p",
        text: "对比正片后可以发现，被剪掉的位置恰好在一段对话的转折处。前面几句都很完整，唯独中间接不上。这种剪法通常意味着中间有一段内容不适合播出，但也可能只是节目时长的常规取舍。",
      },
      {
        type: "quote",
        text: "时长取舍和内容取舍在剪辑上表现得很像，单靠肉眼很难区分，这也是这类传闻难以定性的原因。",
      },
      { type: "h2", text: "为什么先放一放" },
      {
        type: "list",
        items: [
          "流出片段的来源无法确认，存在被二次加工的可能。",
          "节目组尚未就剪辑问题作出任何说明。",
          "在缺乏完整素材的情况下，任何解读都可能是过度联想。",
        ],
      },
      {
        type: "p",
        text: "目前这条线索只能算「有迹可循」。若节目组或嘉宾方后续给出说法，事件性质会清晰很多。",
      },
    ],
  },
  {
    slug: "idol-group-contract",
    title: "男团合约风波升级：工作室深夜发文引粉丝集体刷屏",
    summary:
      "一份措辞克制的深夜声明，让原本只在粉丝内部流通的消息走到了台前。声明里提到的「正常推进」成了最大争议点。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20empty%20concert%20stage%20with%20warm%20gold%20spotlights%20and%20haze%2C%20deep%20red%20curtain%20on%20the%20side%2C%20cinematic%20minimal%20mood%2C%20no%20people&width=900&height=600&seq=dujia-art-05&orientation=landscape",
    topic: "yule",
    topicName: "娱乐圈",
    reliability: "实锤",
    author: "瓜田观察员",
    publishedAt: "2026-09-06",
    time: "23:50",
    readMinutes: 5,
    heat: 71980,
    views: "79.1万",
    isHeadline: false,
    tags: ["合约", "男团", "声明"],
    timeline: [
      { time: "9月5日 全天", title: "粉丝内部流传", desc: "有关合约变动的说法在粉丝社群内小范围流传，未获证实。" },
      { time: "9月6日 23:50", title: "工作室发文", desc: "工作室深夜发布声明，称相关工作「正常推进」，措辞克制。" },
      { time: "9月7日 上午", title: "话题二次发酵", desc: "声明中未提及续约细节，引发新一轮讨论。" },
    ],
    body: [
      {
        type: "p",
        text: "深夜发文往往是权衡过的结果。9月6日晚接近午夜，该男团工作室发布了一份篇幅不长的声明，这是整个事件中第一份来自当事方的正式文本。",
      },
      { type: "h2", text: "声明里说了什么，又没说什么" },
      {
        type: "p",
        text: "声明确认了工作安排仍在推进，并呼吁粉丝理性。但通篇没有出现「续约」「解散」这类关键措辞，也没有给出任何时间节点。对关心这件事的人来说，这份声明更像是回应舆论节奏，而不是交代事实。",
      },
      {
        type: "quote",
        text: "声明的价值在于它确认了「事情存在」，而不是它解释了「事情是什么」。",
      },
      { type: "h2", text: "粉丝为何集体刷屏" },
      {
        type: "p",
        text: "声明发布后，相关话题下出现了集中的粉丝留言。诉求主要集中在两点：希望官方给出明确时间表，以及希望后续行程安排保持透明。这属于粉丝的正常表达，本身没有超出合理范围。",
      },
      { type: "h2", text: "事件定性" },
      {
        type: "list",
        items: [
          "已确认：工作室确实发布了正式声明，说明此事并非空穴来风。",
          "待明确：合约的具体状态、是否涉及续约谈判、后续行程安排。",
          "观察指标：未来两周内是否出现新的官方公告或行程调整。",
        ],
      },
      {
        type: "p",
        text: "这类涉及合约的事件，通常需要当事方给出第二份更具体的说明才会真正落地。站内会持续追踪。",
      },
    ],
  },
  {
    slug: "influencer-couple-clear-photos",
    title: "千万粉情侣博主突然清空合照：双方先后发文各执一词",
    summary:
      "主页合照在一夜之间清空，随后两人分别发文，时间接近但说法不同。粉丝已经整理出对比时间线。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20two%20empty%20chairs%20side%20by%20side%20in%20soft%20warm%20window%20light%2C%20minimal%20cozy%20interior%20still%20life%2C%20warm%20neutral%20tones%2C%20no%20people&width=900&height=600&seq=dujia-art-06&orientation=landscape",
    topic: "qinggan",
    topicName: "情感瓜",
    reliability: "追踪中",
    author: "情感线条",
    publishedAt: "2026-09-05",
    time: "20:15",
    readMinutes: 4,
    heat: 68840,
    views: "74.3万",
    isHeadline: false,
    tags: ["情侣博主", "清空", "各执一词"],
    timeline: [
      { time: "9月5日 01:30", title: "主页变化", desc: "有粉丝发现两人主页的合照内容被集中移除。" },
      { time: "9月5日 18:40", title: "男方发文", desc: "男方发布长文，称「需要一些时间」，未说明具体原因。" },
      { time: "9月5日 20:15", title: "女方发文", desc: "女方随后发文，表述与男方并不完全一致，引发更多讨论。" },
    ],
    body: [
      {
        type: "p",
        text: "情侣博主的动态变化总是被放大观察。9月5日凌晨，有粉丝注意到两人主页上的合照内容被集中移除，动作很整齐，不像零散删除。",
      },
      { type: "h2", text: "两次发文，两种说法" },
      {
        type: "p",
        text: "当天傍晚，男方先发了一篇不长的文字，提到需要一些时间，但没有说明原因。约一个半小时后，女方也发了文，措辞与男方有明显差异。两人都没有点名对方，但放在一起看，语气上的距离感是能感受到的。",
      },
      {
        type: "quote",
        text: "两篇发文的时间间隔和表述差异是客观存在的，但从中推断具体发生了什么，仍然属于过度解读。",
      },
      { type: "h2", text: "粉丝整理的对比时间线" },
      {
        type: "list",
        items: [
          "凌晨清空：主页合照被集中移除，商务合作内容保留。",
          "傍晚发文：双方先后发声，均未明说原因。",
          "次日上午：两人均未再更新，评论区呈现两种截然不同的解读。",
        ],
      },
      { type: "h2", text: "我们怎么看" },
      {
        type: "p",
        text: "感情是两个人的事。作为旁观者，能确认的只有公开动作，无法也不需要替他们下结论。站内会把注意力放在后续是否出现明确表态上，而不是放大每一句措辞。",
      },
    ],
  },
  {
    slug: "actress-airport-ring",
    title: "某女演员机场无名指戒指引猜测：粉丝翻出三个月前同款",
    summary:
      "一张机场照因为手指上的细节被反复放大。粉丝对比后发现，同款戒指在三个月前的行程照里也出现过。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20a%20delicate%20gold%20ring%20resting%20on%20warm%20textured%20fabric%20with%20soft%20directional%20light%2C%20minimal%20editorial%20still%20life%2C%20no%20people&width=900&height=600&seq=dujia-art-07&orientation=landscape",
    topic: "yule",
    topicName: "娱乐圈",
    reliability: "待证实",
    author: "细节捕手",
    publishedAt: "2026-09-04",
    time: "16:50",
    readMinutes: 3,
    heat: 54310,
    views: "58.9万",
    isHeadline: false,
    tags: ["机场照", "戒指", "细节"],
    timeline: [
      { time: "9月3日 下午", title: "机场照流出", desc: "一组行程照被发布，其中一张的手部细节被网友放大讨论。" },
      { time: "9月4日 16:50", title: "同款对比", desc: "粉丝公开对比图，指出同款戒指在三个月前的照片中出现过。" },
    ],
    body: [
      {
        type: "p",
        text: "机场照的信息量有时候比正式通告还大。这一次被放大的是一个很小的细节——照片里手指上多了一枚戒指。",
      },
      { type: "h2", text: "为什么会被讨论" },
      {
        type: "p",
        text: "戒指本身并不稀奇，真正引发讨论的是佩戴的位置。有粉丝进一步翻出三个月前的行程照，发现当时也出现过相似款式的戒指，这让讨论从「偶然」转向了「惯性」。",
      },
      {
        type: "quote",
        text: "同款饰品只能说明佩戴习惯，它离任何实质性的结论都还很远。",
      },
      { type: "h2", text: "理性提示" },
      {
        type: "list",
        items: [
          "机场照存在角度与画质限制，细节可能失真。",
          "同款饰品在娱乐圈非常常见，不足以作为判断依据。",
          "当事人及团队目前均未就此作出任何回应。",
        ],
      },
      {
        type: "p",
        text: "这类由细节引发的讨论，最合适的处理方式就是标注为「待证实」，然后等一个更明确的信号。",
      },
    ],
  },
  {
    slug: "livestream-price-dispute",
    title: "带货一哥被质疑价格虚高：同款商品三方比价结果出炉",
    summary:
      "争议从一句「全网最低」开始。有网友把同款商品在三个渠道的价格做了对比，结果被做成长图广泛传播。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20shopping%20sale%20tags%20and%20price%20labels%20on%20a%20warm%20amber%20backdrop%2C%20minimal%20high%20contrast%20commercial%20graphic%20mood%2C%20no%20text&width=900&height=600&seq=dujia-art-08&orientation=landscape",
    topic: "wanghong",
    topicName: "网红圈",
    reliability: "实锤",
    author: "爆料快线",
    publishedAt: "2026-09-03",
    time: "11:20",
    readMinutes: 4,
    heat: 60230,
    views: "66.1万",
    isHeadline: false,
    tags: ["带货", "比价", "价格争议"],
    timeline: [
      { time: "9月2日 直播", title: "价格表述", desc: "直播过程中出现「全网最低」类表述，被观众截图。" },
      { time: "9月3日 11:20", title: "比价长图", desc: "网友发布三方渠道比价结果，显示不同渠道价格存在差异。" },
    ],
    body: [
      {
        type: "p",
        text: "「全网最低」是带货直播里最常见也最容易被验真的说法。这一次，有网友真的去比了。",
      },
      { type: "h2", text: "比价结果说明了什么" },
      {
        type: "p",
        text: "网友整理的长图对比了三个渠道的同款商品价格。结果显示，直播间价格确实低于其中一个渠道，但与另一个渠道持平，并未做到「全网最低」。差异幅度不大，但足以让表述本身受到质疑。",
      },
      {
        type: "quote",
        text: "价格对比需要考虑赠品、规格与售后差异，直接比数字容易得出不够严谨的结论。",
      },
      { type: "h2", text: "目前确认的事实" },
      {
        type: "list",
        items: [
          "直播中确实出现了绝对化的价格表述。",
          "同款商品在不同渠道存在价格差异，但幅度有限。",
          "主播方与品牌方均未就比价结果作出公开回应。",
        ],
      },
      {
        type: "p",
        text: "这类争议的落点通常在表述是否严谨上。后续是否会有一份更清楚的说明，值得继续观察。",
      },
    ],
  },
  {
    slug: "new-drama-casting-leak",
    title: "新剧选角名单提前泄露：多方沉默反而让传闻更热",
    summary:
      "一份未署名的选角名单在小范围流传，涉及的几位艺人团队都没有回应。越沉默，讨论越多。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20empty%20casting%20room%20with%20warm%20desk%20lamp%20and%20stacked%20script%20pages%2C%20cinematic%20low%20key%20interior%2C%20no%20people%2C%20no%20text&width=900&height=600&seq=dujia-art-09&orientation=landscape",
    topic: "yingshi",
    topicName: "影视瓜",
    reliability: "追踪中",
    author: "追剧小组",
    publishedAt: "2026-09-02",
    time: "15:40",
    readMinutes: 4,
    heat: 47120,
    views: "51.3万",
    isHeadline: false,
    tags: ["选角", "新剧", "泄露"],
    timeline: [
      { time: "9月1日 晚间", title: "名单流出", desc: "一份未署名的选角名单在影视交流群流传，列出若干候选艺人。" },
      { time: "9月2日 15:40", title: "多方未回应", desc: "涉及的几个艺人团队均未回应，剧方也未发布任何说明。" },
    ],
    body: [
      {
        type: "p",
        text: "选角阶段的名单泄露在新剧筹备里并不罕见，但这一次流传的版本信息密度偏高，才引起了更多关注。",
      },
      { type: "h2", text: "为什么大家更在意沉默" },
      {
        type: "p",
        text: "按照以往经验，如果名单完全是假的，通常会很快被辟谣。但这一次，涉及的几个艺人团队都选择了不回应。在信息真空里，沉默容易被解读成默认，这其实是一种误读。",
      },
      {
        type: "quote",
        text: "筹备期的选角本身就在变动中，团队不回应往往只是因为「还没有定论」，而不是「不便承认」。",
      },
      { type: "h2", text: "先看这些事实" },
      {
        type: "list",
        items: [
          "名单来源未署名，无法确认与制作方的关系。",
          "涉及的艺人团队与剧方均未回应。",
          "选角在正式开机前存在大量变数，名单不等于结果。",
        ],
      },
      {
        type: "p",
        text: "这条线索适合放在「追踪中」一栏。等到官方发布定妆或开机信息时，一切自然会清楚。",
      },
    ],
  },
  {
    slug: "band-reunion-clue",
    title: "解散多年的乐队被曝将合体：场地预订记录成关键线索",
    summary:
      "一条没有名字的场地预订记录被翻出，时间和规模都对得上，于是「合体」的猜测重新被点燃。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20empty%20concert%20venue%20with%20warm%20gold%20stage%20lights%20and%20silhouetted%20equipment%2C%20cinematic%20atmospheric%20mood%2C%20no%20people&width=900&height=600&seq=dujia-art-10&orientation=landscape",
    topic: "yule",
    topicName: "娱乐圈",
    reliability: "待证实",
    author: "瓜田观察员",
    publishedAt: "2026-09-01",
    time: "19:00",
    readMinutes: 4,
    heat: 43980,
    views: "47.6万",
    isHeadline: false,
    tags: ["乐队", "合体", "演唱会"],
    timeline: [
      { time: "8月31日 晚间", title: "预订记录流出", desc: "一份场馆预订信息在乐迷社区流传，档期与规模引发联想。" },
      { time: "9月1日 19:00", title: "官方未证实", desc: "相关方均未对合体传闻作出回应。" },
    ],
    body: [
      {
        type: "p",
        text: "乐迷对合体的期待，往往能让一条模糊的线索发酵得很快。这一次的起点是一份场馆预订信息。",
      },
      { type: "h2", text: "线索本身有多硬" },
      {
        type: "p",
        text: "预订记录的时间档期落在传统演出旺季，场馆规模也符合一支有一定号召力的乐队需求。但记录中并没有出现乐队名称，这种「对得上但不点名」的状态，正是传闻最容易膨胀的土壤。",
      },
      {
        type: "quote",
        text: "场地预订属于常规商业行为，同一档期可能有多个项目在谈，把记录直接对应到某一个乐队，证据链是不完整的。",
      },
      { type: "h2", text: "理性看待" },
      {
        type: "list",
        items: [
          "预订记录未指向具体演出方，无法确认与哪支乐队相关。",
          "相关方均未回应，传闻仍停留在猜测阶段。",
          "演出批文与开票信息才是更可靠的判断依据。",
        ],
      },
      {
        type: "p",
        text: "如果后续出现官方批文或开票信息，这条线索才具备真正的分量。在那之前，把它当作期待就好。",
      },
    ],
  },
  {
    slug: "love-show-guests-trip",
    title: "恋综嘉宾线下同游被偶遇：节目组回应只字未提",
    summary:
      "有网友称在景区偶遇两位恋综嘉宾同行，并发布了模糊照片。节目组的回应重点放在了「尊重嘉宾隐私」上。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20scenic%20wooden%20boardwalk%20through%20warm%20autumn%20trees%20at%20golden%20hour%2C%20soft%20bokeh%2C%20no%20people%2C%20travel%20editorial%20photography&width=900&height=600&seq=dujia-art-11&orientation=landscape",
    topic: "qinggan",
    topicName: "情感瓜",
    reliability: "追踪中",
    author: "情感线条",
    publishedAt: "2026-08-31",
    time: "13:10",
    readMinutes: 3,
    heat: 39870,
    views: "43.2万",
    isHeadline: false,
    tags: ["恋综", "偶遇", "同游"],
    timeline: [
      { time: "8月30日 下午", title: "网友偶遇", desc: "有网友称在景区遇到两位嘉宾同行，并发布了照片。" },
      { time: "8月31日 13:10", title: "节目组回应", desc: "节目组回应措辞围绕「尊重嘉宾隐私」，未确认或否认任何关系。" },
    ],
    body: [
      {
        type: "p",
        text: "恋综节目结束后，嘉宾的线下动态总是最能牵动观众。这一次的起点是一组来自景区的偶遇照片。",
      },
      { type: "h2", text: "照片能说明什么" },
      {
        type: "p",
        text: "照片画面较远，人物辨识度有限。发布者称两人同行，但画面本身并不能确认行程的具体安排。这类偶遇信息在传播中容易被不断补充细节，而补充的部分往往没有依据。",
      },
      {
        type: "quote",
        text: "节目组的回应重点落在隐私上，这是对嘉宾的保护，也是一种不介入私人关系判断的常规处理。",
      },
      { type: "h2", text: "目前状态" },
      {
        type: "list",
        items: [
          "偶遇信息来自网友发布，画面辨识度有限。",
          "节目组未对关系作任何确认或否认。",
          "两位嘉宾本人均未回应。",
        ],
      },
      {
        type: "p",
        text: "把它放在「追踪中」，等一个更明确的表态会更合适。感情类的传闻，本就不该由旁观者替当事人定论。",
      },
    ],
  },
  {
    slug: "exclusive-chat-record",
    title: "独家首发：某合作方内部聊天记录流出，事件出现关键转折",
    summary:
      "一份标注了时间与工作群的聊天记录截图被提供给站内。我们对内容做了打码处理，并标注了尚无法独立核实的信息。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20breaking%20news%20alert%20light%20on%20a%20dark%20surface%20with%20warm%20red%20and%20gold%20streaks%2C%20minimal%20high%20contrast%20graphic%20mood%2C%20no%20text&width=900&height=600&seq=dujia-art-12&orientation=landscape",
    topic: "shoufa",
    topicName: "首发追踪",
    reliability: "实锤",
    author: "独家首发组",
    publishedAt: "2026-08-30",
    time: "22:05",
    readMinutes: 5,
    heat: 82150,
    views: "91.7万",
    isHeadline: false,
    tags: ["独家", "首发", "关键转折"],
    timeline: [
      { time: "8月30日 20:00", title: "素材送达", desc: "站内收到一份匿名提供的聊天记录截图，包含工作群名称与时间标记。" },
      { time: "8月30日 21:30", title: "交叉比对", desc: "已将截图时间与公开行程记录做了初步比对，时间点可以对应。" },
      { time: "8月30日 22:05", title: "独家首发", desc: "在完成打码处理后，站内发布首发内容，并标注无法独立核实的部分。" },
    ],
    body: [
      {
        type: "p",
        text: "这是一条站内首发线索。8月30日晚，我们收到一份匿名提供的聊天记录截图，内容涉及某次合作的工作安排。按照站内流程，我们在发布前做了一轮交叉比对。",
      },
      { type: "h2", text: "我们做了什么核实" },
      {
        type: "p",
        text: "首先确认截图中的时间标记与公开行程记录能够对应，这一点让素材的可信度上升。其次核对了群名称的命名习惯，与行业内同类工作群一致。但需要说明的是，我们无法独立验证截图的完整性，也无法确认发言者身份，因此发布时对所有个人信息做了打码。",
      },
      {
        type: "quote",
        text: "标注「可核实」与「无法核实」的边界，是我们做首发报道时最重要的一步。",
      },
      { type: "h2", text: "这份素材改变了什么" },
      {
        type: "p",
        text: "在此之前，相关讨论基本停留在时间巧合上。这份素材第一次提供了「有人提前知晓安排」的迹象，让事件从猜测走向了可讨论的层面。当然，「提前知晓」本身并不等同于任何不当行为，两者之间还有很长的距离。",
      },
      { type: "h2", text: "已确认与待确认" },
      {
        type: "list",
        items: [
          "已确认：素材中的时间标记与公开行程存在对应关系。",
          "待确认：截图完整性与发言者身份，均无法独立验证。",
          "后续跟进：已向相关方发出问询，如有回应将第一时间更新。",
        ],
      },
      {
        type: "p",
        text: "作为首发方，我们有责任把不确定的部分同样说清楚。这条线索会持续更新，任何新的公开节点都会补进时间线。",
      },
    ],
  },
];